import request from '@/utils/request'

// 查询邀请注册奖励分页
export function pageInviteReward(query) {
  return request({
    url: '/user/invite/reward/page',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query
  })
}

// 查询邀请注册奖励列表
export function listInviteReward(query) {
  return request({
    url: '/user/invite/reward/list',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query
  })
}
